import { RouteRecordName } from 'vue-router'

export enum RoutePageLayouts {
  default = 'default',
  mobile = 'mobile',
  empty = 'empty',
  profileDesktop = 'profile-desktop',
}

export const profileLayoutRoutes: RouteRecordName[] = [
  'profile',
  'profile-orders',
  'profile-orders-id',
  'profile-bonus-history',
  'profile-cards',
  'profile-notifications',
  'profile-password-change',
  'profile-promocodes',
  'profile-settings',
]

export const emptyLayoutRoutes: RouteRecordName[] = ['pay']

export const LOGIN_PAGE_NAME = 'login'
